export const MOBILE_MEDIA_QUERY = '(hover: none) and (pointer: coarse)';

export const subscribeToLanguage = (onChange: () => void): (() => void) => {
  window.addEventListener('languagechange', onChange);

  return () => {
    window.removeEventListener('languagechange', onChange);
  };
};

export const getLanguage = (): string => window.navigator.language;
